// extracted by mini-css-extract-plugin
export var wordContainer = "_r1-0";